import { Injectable } from '@angular/core';

import { grpcOperator } from '@lyra/app/core/api/grpc/pipe-operators/grpc';
import { MainApi } from '@mark/web-contracts';
import { from } from 'rxjs';

import { GRpcRequestType } from '../grpc-class.type';
import { GrpcCommonService } from './common.service';

export type IUpdateInfo = GRpcRequestType<MainApi.UserDataGrpcWebContractClient['UpdateInfo']>;

@Injectable()
export class UserDataGrpcWebContractService extends GrpcCommonService<MainApi.UserDataGrpcWebContractClient> {
  constructor(protected _GrpcContract: MainApi.UserDataGrpcWebContractClient) {
    super();
  }

  updateInfo(request: IUpdateInfo) {
    return from(
      this._GrpcContract.UpdateInfo(
        new MainApi.UpdateInfoUserWpcRequest(MainApi.UpdateInfoUserWpcRequest.fromObject(request)),
        this.getMetadata(),
      ),
    ).pipe(grpcOperator());
  }
}
